<template>
  <div class="event">
    <svg class="event-icon" width="291" height="146" viewBox="0 0 291 146" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect class="event-icon__grey" x="66" y="41" width="34" height="100" rx="4" stroke="#F28E22" stroke-width="5"/>
      <rect class="event-icon__white" x="3" y="3" width="160" height="100" rx="4" stroke="#F28E22" stroke-width="5"/>
      <rect class="event-icon__white" x="243" y="61" width="45" height="80" rx="4" stroke="#F28E22" stroke-width="5"/>
      <path class="event-icon__white" d="M208 123.5C196.8 123.9 184.5 122.5 175 110C177 126.5 192 135 208.5 133.5L209 140.5L227 126.5L207.5 116.5L208 123.5Z" stroke="#F28E22" stroke-width="5"/>
    </svg>
    <h1 class="event-title" v-text="$t('event.title_mobile_required')"></h1>
    <div class="event-text" v-html="$t('event.text_mobile_required')"></div>
  </div>
</template>

<script>
export default {
  name: 'JoinEvent'
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');

  .event {
    flex: 1;
    margin: 120px auto 0;
    padding: 16px;
    text-align: center;
    font-family: 'Roboto';
    line-height: 24px;
    letter-spacing: 0.15px;
    background-color: var(--background-color, @background-color);
    & &-title {
      margin: 0 0 16px;
      color: var(--title-color, @dark);
      font-weight: 500;
      font-size: 24px;
      text-align: center;
    }
    & &-text {
      margin: 0 0 36px;
      color: @grey-600;
      font-size: 16px;
      text-align: center;
      letter-spacing: 0.15px;
    }
    & &-icon {
      display: inline-block;
      margin: 0 0 36px;
      &__white {
        fill: var(--background-color, @white);
      }
      &__grey {
        fill: var(--background-contrl, #F2F2F7);
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .event {
      margin: 40px auto 0;
    }
  }

  @media screen and (max-width: 768px) {
    .event {
      & &-title {
        font-size: 18px;
      }
      & &-text {
        font-size: 14px;
        line-height: 1.2;
      }
    }
  }
</style>